import { Map } from 'immutable';
import * as pet from '../../actions/relocation/relocationPet';

const initialState = Map({
  // the pet list retrieved from api
  petList: [],
  // check to determine if pet list is fetched
  petFetched: false,
  // gender types
  genderTypes: [],
  // pet size
  petSizes: [],
  // pet types
  petTypes: [],
  // checker for pet validation
  petValidation: false,
});

const actionsMap = {
  [pet.UPDATE_PETLIST]: (state, action) => {
    return state.set('petList', action.petList);
  },
  [pet.PETLIST_FETCHED]: (state, action) => {
    return state.set('petFetched', action.data);
  },
  [pet.SET_GENDER_TYPES]: (state, action) => {
    return state.set('genderTypes', action.data);
  },
  [pet.SET_PET_SIZES]: (state, action) => {
    return state.set('petSizes', action.data);
  },
  [pet.SET_PET_TYPES]: (state, action) => {
    return state.set('petTypes', action.data);
  },
  [pet.UPDATE_PET_DETAILS_VALIDATION]: (state, action) => {
    return state.set('petValidation', action.data);
  },
};

export default function facilities(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}